import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from './core/guards/auth.guard'
import { HasRoleGuard } from './core/guards/has-role.guard'
import { DashboardLayoutComponent } from './core/layouts/dashboard-layout/dashboard-layout.component'
import { DashboardLayoutModule } from './core/layouts/dashboard-layout/dashboard-layout.module'
import { SimpleLayoutComponent } from './core/layouts/simple-layout/simple-layout.component'
import { AppRoutes, ErrorRoutes, Role } from './shared/constants/enums'

const routes: Routes = [
    { path: AppRoutes.UNAUTHORIZED, pathMatch: 'full', redirectTo: AppRoutes.LOGGED_OUT },
    {
        path: '',
        component: DashboardLayoutComponent,
        children: [
            {
                path: AppRoutes.GUARANTEE_ORDERS,
                loadChildren: () =>
                    import('./features/guarantee-order/guarantee-order.module').then((m) => m.GuaranteeOrderModule),
                canActivateChild: [HasRoleGuard],
                data: { allowedRoles: [Role.SIGNING, Role.ENTERING, Role.BROWSING] }
            },
            {
                path: AppRoutes.STYLE_GUIDE,
                loadChildren: () => import('./features/style-guide/style-guide.module').then((m) => m.StyleGuideModule)
            },
            {
                path: '',
                loadChildren: () => import('./features/desktop/desktop.module').then((m) => m.DesktopModule)
            }
        ],
        canActivateChild: [AuthGuard]
    },
    {
        path: '',
        component: SimpleLayoutComponent,
        children: [
            { path: AppRoutes.LOGGED_OUT, loadComponent: () => import('./features/logged-out/logged-out.component') },
            { path: AppRoutes.ERROR, loadChildren: () => import('./features/error/error.module') }
        ]
    },
    { path: '**', redirectTo: `${AppRoutes.ERROR}/${ErrorRoutes.NOT_FOUND}` }
]

@NgModule({
    imports: [
        DashboardLayoutModule,
        RouterModule.forRoot(routes, {
            useHash: false,
            paramsInheritanceStrategy: 'always'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
